import InputTextContent from './InputTextContent';

export default InputTextContent;
